import React from "react";
import { getLedgerSyncStatus } from "../ledgerSyncUtils";

// Same anatomy as StatusBadge (6px dot + label), reused here so the ledger
// sync pill reads as part of the same pill family, not a one-off.
export default function LedgerSyncBadge({ row }) {
  const { label, color, backgroundColor } = getLedgerSyncStatus(row);

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "2px 10px",
        borderRadius: 16,
        fontFamily: "Inter-Medium",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: "18px",
        whiteSpace: "nowrap",
        color,
        backgroundColor,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: "currentColor",
          flexShrink: 0,
        }}
      />
      <span>Ledger: {label}</span>
    </span>
  );
}
